export const SWITCH_DISPLAY_BANNER = 'SWITCH_DISPLAY_BANNER';

export const displayBanner = (enable) => {
    return {
        type: SWITCH_DISPLAY_BANNER,
        payload: enable,
    };
};
